import { TrlPillParcExec } from './TrlPillParcExec';

export { TrlPillParcExec } from './TrlPillParcExec';
export default TrlPillParcExec;
